
export const bonusChargeDefaultHeader_Account = [
	{
		settings: true,
		text: "Id",
		value: "id",
		valueFilter: 'filter_id',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Date created",
		value: "create_at",
		valueFilter: 'filter_create_at',
		func: true,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Salary period (month)",
		value: "salary_month",
		valueFilter: 'filter_salary_month',
		func: true,
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Type",
		value: "type",
		valueFilter: "filter_type",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' }
	},
	{
		settings: true,
		text: "Role (department)",
		value: "department",
		valueFilter: "filter_department",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Employee",
		value: "employee",
		valueFilter: "filter_employee",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' }
	},
	{
		settings: true,
		text: "Description",
		value: "description",
		valueFilter: "filter_description",
		func: true,
		sortable: true,
		model: { value: 'note' },
		left: true
	},
	{
		settings: true,
		text: "Sum",
		value: "total",
		valueFilter: "filter_total",
		func: true,
		sortable: true,
		model: { value: 'number' },
		left: true,
		dense: true,
		footer: "sumDifference",
		dollar: true
	},
	{
		settings: true,
		text: "File",
		value: "file",
		file: { iconId: 'icon_view', w: 20, h: 20 },
		align: 'center'
	},
	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit',
				text: 'Edit this record',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete this record',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	},
];
export const bonusChargeDefaultHeader_User = [
	{
		settings: true,
		text: "Id",
		value: "id",
		valueFilter: 'filter_id',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Date created",
		value: "create_at",
		valueFilter: 'filter_create_at',
		func: true,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Salary period (month)",
		value: "salary_month",
		valueFilter: 'filter_salary_month',
		func: true,
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Type",
		value: "type",
		valueFilter: "filter_type",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' }
	},
	// {
	// 	settings: true,
	// 	text: "Role (department)",
	// 	value: "department",
	// 	valueFilter: "filter_department",
	// 	func: true,
	// 	filterable: false,
	// 	sortable: true,
	// 	model: { value: 'list' },
	// 	left: false,
	// 	dense: true
	// },
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	// {
	// 	settings: true,
	// 	text: "Employee",
	// 	value: "employee",
	// 	valueFilter: "filter_employee",
	// 	func: true,
	// 	filterable: false,
	// 	sortable: true,
	// 	model: { value: 'list' }
	// },
	{
		settings: true,
		text: "Description",
		value: "description",
		valueFilter: "filter_description",
		func: true,
		sortable: true,
		model: { value: 'note' },
		left: true
	},

	{
		settings: true,
		text: "Sum",
		value: "total",
		valueFilter: "filter_total",
		func: true,
		sortable: true,
		model: { value: 'number' },
		left: true,
		dense: true,
		footer: "sumDifference",
		dollar: true
	},
	{
		settings: true,
		text: "File",
		value: "file",
		file: { iconId: 'icon_view', w: 20, h: 20 },
		align: 'center'
	},
	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit',
				text: 'Edit',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	},
];
